<template>
  <div class="enamad-1">
    <template v-if="findAttributeOnSiteInfo('symbol').length > 0">
      <div v-for="symbol in findAttributeOnSiteInfo('symbol')" class="enamad-1-wrapper">
        <div v-html="symbol" class="enamad-1-item"></div>
      </div>
    </template>
  </div>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: "Enamad1"
})
</script>

<style scoped>

</style>